import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Pagination } from "antd";
import moment from "moment";
import { useNavigate, useSearchParams } from "react-router-dom";
import { API } from "../../Config/API";
import { GET } from "../../utils/apiCalls";
import Header from "../../component/header";
import Footer from "../../component/footer/footer";
// import StickyAdds from "../../component/adds/stickyAdds";
import { onImgErrorFallback } from "../../utils/mediaFallback";
import {
  EnhancedEpaperResponse,
  EpaperItem,
  EpaperQueryParams,
} from "../../types/epaper.types";
import "./styles.scss";
import { FaArrowLeft } from "react-icons/fa6";
import { useSubscriptionCheck } from "../../hooks/useSubscriptionCheck";
import SubscriptionModal from "../../components/SubscriptionModal";
import RenewalModal from "../../components/RenewalModal";

function NjayarPrabhaathamAll() {
  const navigate = useNavigate();
  const { status: subStatus, daysLeft, endDate } = useSubscriptionCheck();

  const [showRenewal, setShowRenewal] = useState(false);
  const [subModal, setSubModal] = useState<{
    visible: boolean;
    type: "expired" | "expiring_soon" | "none";
    pendingItem: EpaperItem | null;
  }>({ visible: false, type: "expired", pendingItem: null });
  const [searchParams, setSearchParams] = useSearchParams();

  // Get initial values from URL params or use defaults
  const initialPage = parseInt(searchParams.get("page") || "1");
  const initialPageSize = parseInt(searchParams.get("pageSize") || "12");

  const [page, setPage] = useState(initialPage);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [loading, setLoading] = useState(true);
  const [njayar, setNjayar] = useState<EpaperItem[]>([]);
  const [meta, setMeta] = useState<any>(null);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // Set initial URL params if they don't exist
  useEffect(() => {
    if (!searchParams.get("page") || !searchParams.get("pageSize")) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("page", page.toString());
      newParams.set("pageSize", pageSize.toString());
      setSearchParams(newParams, { replace: true });
    }
    setIsInitialLoad(false);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    loadEnhancedData();
  }, [page, pageSize]);

  // Update URL when page or pageSize changes (but not on initial load)
  useEffect(() => {
    if (!isInitialLoad) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("page", page.toString());
      newParams.set("pageSize", pageSize.toString());
      setSearchParams(newParams, { replace: true });
    }
  }, [page, pageSize, isInitialLoad]);

  const loadEnhancedData = async () => {
    try {
      setLoading(true);

      const params: EpaperQueryParams = {
        edition: "njayar",
        page: page,
        take: pageSize,
        sort: "desc",
      };

      const response = (await GET(
        API.EPAPER_ENHANCED,
        params
      )) as EnhancedEpaperResponse;

      if (response?.data) {
        setNjayar(response.data);
        setMeta(response.meta);
        setTotal(response.meta.itemCount);
      } else {
        setNjayar([]);
        setTotal(0);
        setMeta(null);
      }
      setLoading(false);
    } catch (err) {
      console.error("Error loading enhanced epaper data:", err);
      setLoading(false);
      setNjayar([]);
      setTotal(0);
      setMeta(null);
    }
  };

  const preventImageDrag = (e: React.DragEvent<HTMLImageElement>) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  const doNavigate = (item: EpaperItem) => {
    navigate(
      `/details/${item?.edition}/${moment(item?.date).format(
        "YYYY-MM-DD"
      )}/1/${item?.id}`
    );
  };

  const handleClick = (item: EpaperItem) => {
    // Subscription locking temporarily disabled
    // if (subStatus === "none") {
    //   setSubModal({ visible: true, type: "none", pendingItem: item });
    //   return;
    // }
    // if (subStatus === "expired") {
    //   setSubModal({ visible: true, type: "expired", pendingItem: item });
    //   return;
    // }
    // if (subStatus === "expiring_soon") {
    //   setSubModal({ visible: true, type: "expiring_soon", pendingItem: item });
    //   return;
    // }
    doNavigate(item);
  };

  return (
    <div>
      <Header />
      <div className="Homescreen-box">
        <Container>
          {/* <GoogleAds /> */}
          <br />
          <div className="Head-section-m">
            <div className="Head-n">
              <span onClick={() => navigate(`/home`)} className="all-back-btn">
                <FaArrowLeft color={"rgb(5, 118, 183)"} />{" "}
              </span>
              &nbsp;Njayar Prabhaatham
            </div>
          </div>

          {loading ? (
            <div className="Homescreen-loading">Loading . . .</div>
          ) : njayar.length ? (
            <>
              <Row>
                {njayar.map((item: EpaperItem) => {
                  return (
                    <Col
                      sm={3}
                      key={item?.id}
                      onClick={() => handleClick(item)}
                    >
                      <div className="Homescreen-item">
                        <div className="Homescreen-itemBox">
                          <img
                            src={item?.image}
                            className="Homescreen-itemImg"
                            alt="suprabhaatham-epaper"
                            draggable={false}
                            onDragStart={preventImageDrag}
                            onContextMenu={(e) => e.preventDefault()}
                            onError={onImgErrorFallback}
                          />
                        </div>

                        <div className="Homescreen-itemBox2">
                          <div>
                            {item?.edition}&nbsp;-&nbsp;
                            {moment(item?.date).format("DD-MM-yyyy")}
                          </div>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>

              {/* Pagination */}
              <div
                className="pagingBox"
                style={{ textAlign: "center", marginTop: 20 }}
              >
                <Pagination
                  current={page}
                  total={total}
                  pageSize={pageSize}
                  showSizeChanger
                  showPrevNextJumpers
                  pageSizeOptions={["12", "24", "48"]}
                  onChange={(p, size) => {
                    setPage(p);
                    if (size) setPageSize(size);
                  }}
                  onShowSizeChange={(p, size) => {
                    setPage(1); // Reset to page 1 when page size changes
                    setPageSize(size);
                  }}
                />
                <br />
                <div className="page-text">{`${
                  meta ? `(Page ${meta.page} of ${meta.pageCount})` : ""
                }`}</div>
              </div>
            </>
          ) : (
            <div className="Homescreen-loading">No data found</div>
          )}
          <br />
          {/* <GoogleAds /> */}
        </Container>
        {/* <StickyAdds /> */}
      </div>
      <Footer />

      {subModal.visible && (
        <SubscriptionModal
          type={subModal.type}
          visible={subModal.visible}
          daysLeft={daysLeft}
          endDate={endDate}
          onClose={() => setSubModal((s) => ({ ...s, visible: false }))}
          onContinue={() => {
            if (subModal.pendingItem) doNavigate(subModal.pendingItem);
          }}
          onRenew={() => setShowRenewal(true)}
        />
      )}

      <RenewalModal
        visible={showRenewal}
        onClose={() => setShowRenewal(false)}
      />
    </div>
  );
}

export default NjayarPrabhaathamAll;
